import debounce from 'lodash/debounce';

class SessionRenewal {
	constructor(form, options = {}) {
		this.form = form;
		this.options = Object.assign(
			{
				timeout: 60000,
				url: '/api/system/session'
			},
			options
		);

		this.init();
	}

	init() {
		const { timeout } = this.options;

		this.form.addEventListener('click', debounce(this.renew.bind(this), timeout));
		this.form.addEventListener('focus', debounce(this.renew.bind(this), timeout), true);
	}

	renew() {
		fetch(this.options.url);
	}
}

function initSessionRenewal(form, options) {
	new SessionRenewal(form, options);
}

export { SessionRenewal, initSessionRenewal };
